import { mapGetters } from 'vuex'
import { menus } from '../router'

export default {
  computed: {
    ...mapGetters(['admin', 'store', 'permission_list_key']),
    menus() {
      return this.getMenus(menus)
    },
    PRPath() {
      const PRoute = this.$route.matched[0] || {}
      return PRoute.path || '/'
    },
    PMenu() {
      return menus.find(o => o.path === this.PRPath)
    },
  },
  methods: {
    push({ path }) {
      this.$router.push(path)
    },
    isMenuShow({ meta }) {
      return !meta.hidden
    },
    getMenus(menus = []) {
      return menus.filter(o => {
        if (o.children) {
          o.children = this.getMenus(o.children)
        }
        return this.isPermission(o)
      })
    },
    //目录验证
    isPermission({ meta: e }) {
      //是否是可显示的菜单
      const isHidden = !e.hidden
      //是否为最后一级子目录
      const isChildren = !e.children || e.children.length
      //是否拥有所有权限
      const isAdmin = this.admin || !this.$config.permission
      //是否有权限访问
      const isPermission = this.permission_list_key[e.code]

      //自定义规则
      const rules = {
        undefined: true,
        mainStore: this.store.is_super
      }

      return isHidden && isChildren && (isAdmin || isPermission) && rules[e.rule]
    },
  }
}